module.exports = __webpack_public_path__ + "static/media/down-arrow.fc94dda0.svg";